<template>
  <div
    class="m-pc-metting-schedule top-nav"
    id="meetingAgenda"
    v-if="extras.meetingAgenda.display == 1"
  >
    <div class="pc-metting-content u-w1200">
      <Title
        v-if="extras.meetingAgendaTitle.display == 1"
        :title="extras.meetingAgendaTitle.model || title"
      />
      <div class="pc-agendas-info">
        <div class="pc-content-info" v-if="agendas.length > 0">
          <swiper
            v-if="agendas.length > 1"
            :options="swiperOptions"
            class="pc-metting-time"
          >
            <swiper-slide
              class="date swiper-slide"
              :class="{
                'cursor-default': isSetting == 1,
              }"
              v-for="(item, index) in agendas"
              :key="index"
            >
              <div class="date-cnt" @click="DayClick(item)">
                <span class="icon icontemp time"></span>
                <span :class="{ active: item.agendaDate == currentId }">{{
                  item.agendaDate | formatDate
                }}</span>
              </div>
            </swiper-slide>
          </swiper>
          <div v-if="agendas.length == 1" class="pc-metting-time single">
            <div class="swiper-wrapper">
              <div
                class="date swiper-slide"
                :class="{
                  'cursor-default': isSetting == 1,
                }"
                v-for="(item, index) in agendas"
                :key="index"
              >
                <div class="date-cnt" @click="DayClick(item)">
                  <span class="icon icontemp time"></span>
                  <span :class="{ active: item.agendaDate == currentId }">{{
                    item.agendaDate | formatDate
                  }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="m-tab-list"
            v-if="
              extras &&
              extras.subMeetingAgenda &&
              extras.subMeetingAgenda.display == 1
            "
            v-show="
              (agendasJson.itemsSubSeminar &&
                agendasJson.itemsSubSeminar.length > 0) ||
              isSetting == 1
            "
          >
            <div
              class="tab u-mr30"
              @click="changeAgendaType(0)"
              :class="{
                'cursor-default': isSetting == 1,
                active: agendaType === 0,
              }"
            >
              大会日程
            </div>
            <div
              class="tab u-mr30"
              @click="changeAgendaType(1)"
              :class="{
                'cursor-default': isSetting == 1,
                active: agendaType === 1,
              }"
            >
              分会场日程
            </div>
          </div>
          <div class="g-schedule-info">
            <ul class="tab-body" v-if="agendaType === 0 && agendasJson.items">
              <li
                class="u-mb25"
                v-for="(field, index) in agendasJson.items"
                :key="index"
              >
                <div
                  class="timeleft u-mt15"
                  v-show="field.hidden != 1 || extras.mergeAgenda.display == 0"
                >
                  {{ field.startTime | formatTime }} -
                  {{ field.endTime | formatTime }}
                </div>
                <div class="timeright">
                  <span class="timeright-block"></span>
                  <div
                    class="top topfont"
                    v-html="field.name"
                    style="margin-bottom: 5px"
                  ></div>
                  <div
                    class="guest"
                    v-show="
                      extras.AgendaRemark && extras.AgendaRemark.display == 1
                    "
                    v-html="field.remark"
                  ></div>
                  <div class="guest">{{ field.address }}</div>
                  <div
                    class="guest"
                    v-for="(guest, index) in field.guests"
                    :key="index"
                  >
                    <span class="">{{ guest.name }}</span>
                    <span class="" v-if="guest.enterprise"
                      >&nbsp;|&nbsp;{{ guest.enterprise }}</span
                    >
                    <span class="" v-if="guest.duty"
                      >&nbsp;|&nbsp;{{ guest.duty }}</span
                    >
                  </div>
                </div>
              </li>
            </ul>
            <div
              class="tab-body-branch-venue"
              v-if="agendaType === 1 && agendasJson.itemsSubSeminar"
            >
              <div
                class="branch-venue-box"
                v-for="(field, index) in agendasJson.itemsSubSeminar"
                :key="index"
              >
                <div class="g-meeting-address">
                  <div class="left1 u-mr10" v-if="field.subSeminarName">
                    <img
                      class="g-meeting-address-icon"
                      src="../../assets/images/pc/seminar-name.png"
                    />
                    <span class="g-meeting-name">{{
                      field.subSeminarName
                    }}</span>
                  </div>
                  <div class="left1" v-if="field.subSeminarAddress">
                    <span class="g-meeting-address-icon icontemp"
                      >&#xe666;</span
                    >
                    <span class="g-meeting-address-text">{{
                      field.subSeminarAddress
                    }}</span>
                  </div>
                </div>
                <ul class="tab-body">
                  <li class="u-mb25">
                    <div
                      class="g-agendas-container"
                      v-if="field.items.length > 0"
                    >
                      <div
                        class="g-sub-seminar"
                        v-for="(item, agendaIndex) in field.items"
                        :key="agendaIndex"
                      >
                        <div
                          class="timeleft u-mt15"
                          v-if="
                            item.hidden != 1 || extras.mergeAgenda.display == 0
                          "
                        >
                          {{ item.startTime | formatTime }} -
                          {{ item.endTime | formatTime }}
                        </div>
                        <div class="timeright">
                          <span class="timeright-block"></span>
                          <div class="top topfont" v-html="item.name"></div>
                          <div
                            class="guest"
                            v-show="
                              extras.AgendaRemark &&
                              extras.AgendaRemark.display == 1
                            "
                            v-html="item.remark"
                          ></div>
                          <div class="guest">
                            {{ item.address }}
                          </div>
                          <div
                            class="guest"
                            v-for="(guest, index) in item.guests"
                            :key="index"
                          >
                            <span class="">{{ guest.name }}</span>
                            <span class="" v-if="guest.enterprise"
                              >&nbsp;|&nbsp;{{ guest.enterprise }}</span
                            >
                            <span class="" v-if="guest.duty"
                              >&nbsp;| {{ guest.duty }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="m-nodata-body u-mt0 u-mb0">
              <div
                class="m-nodata"
                v-if="
                  agendaType === 0 &&
                  agendasJson.items &&
                  agendasJson.items.length === 0
                "
              >
                <img src="@/assets/images/nodata.png" />
                <div class="m-nodata">暂无数据</div>
              </div>
            </div>

            <div
              class="m-nodata-body"
              v-if="
                agendaType === 1 && agendasJson.itemsSubSeminar.length === 0
              "
            >
              <img src="@/assets/images/nodata.png" />
              <div class="m-nodata">暂无数据</div>
            </div>
          </div>
        </div>
        <div class="m-nodata-body" v-if="agendas.length == 0">
          <img src="@/assets/images/nodata.png" />
          <div class="m-nodata">暂无数据</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/index/Title.vue";
import { URLS } from "fire-wind-water";

export default {
  name: "Header",
  components: {
    Title,
  },
  props: {
    agendas: [],
    extras: Object,
  },
  data() {
    return {
      title: "会议日程",
      num: 0,
      isSetting: 0,
      agendaType: 0,
      currentId: "",
      agendasDates: [],
      agendasJson: [],
      swiperOptions: {
        slidesPerView: "6",
        grabCursor: true,
        setWrapperSize: true, //使用flexbox布局(display: flex)
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      },
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    if (this.agendas.length > 0) {
      this.agendasJson = this.formatAgendaJson(this.agendas[0]);
      this.agendasJson.itemsSubSeminar = this.agendas[0]
        ? this.formatSubSeminarAgendaJson(this.agendas[0].itemsSubSeminar)
        : [];
      this.currentId = this.agendas[0].agendaDate;
    }
  },

  methods: {
    changeAgendaType(type) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.agendaType = type;
    },
    DayClick(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      //this.num = index;
      console.log(item);
      this.agendaType = 0;
      this.agendasJson = this.formatAgendaJson(item);
      this.currentId = item.agendaDate;
    },
    formatAgendaJson(items) {
      // eslint-disable-next-line no-empty
      let agenda = [];
      for (let i = 0; i < items.items.length; i++) {
        let AgendaStr = this.getAgendaDate(
          items.items[i].startTime,
          items.items[i].endTime
        );
        if (agenda.indexOf(AgendaStr) !== -1) {
          items.items[i].hidden = 1;
        } else {
          agenda.push(AgendaStr);
          items.items[i].hidden = 0;
        }
      }

      if (items.itemsSubSeminar && items.itemsSubSeminar.length > 0) {
        items.itemsSubSeminar = this.formatSubSeminarAgenda(items);
      }

      return items;
    },

    formatSubSeminarAgenda(items) {
      for (let i = 0; i < items.itemsSubSeminar.length; i++) {
        items.itemsSubSeminar[i] = this.formatAgendaJson(
          items.itemsSubSeminar[i]
        );
      }
      return items.itemsSubSeminar;
    },
    formatSubSeminarAgendaJson(items) {
      // eslint-disable-next-line no-empty

      let agenda = [];
      for (let i = 0; i < items.length; i++) {
        let AgendaStr = this.getAgendaDate(
          items[i].subSeminarStartTime,
          items[i].subSeminarEndTime
        );
        if (agenda.indexOf(AgendaStr) !== -1) {
          items[i].hidden = 1;
        } else {
          agenda.push(AgendaStr);
          items[i].hidden = 0;
        }
      }
      return items;
    },
    getAgendaDate(startTime, endTime) {
      return startTime + "_" + endTime;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-wrapper {
  justify-content: center;
}
</style>
